import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { successSubscription } from "../api/services";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import { useDispatch} from 'react-redux';
import {loginSuccess} from '../slices/authSlice';
const PaymentSuccess = () => {
  const dispatch = useDispatch()
  const [planId, setPlanId] = useState(null);
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setPlanId(params.get("plan_id"));

    setTimeout(() => {
      window.history.replaceState({}, document.title, "/payment-success");
    }, 0);

    const timer = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate("/");
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [location, navigate]);

  useEffect(() => {
  if (planId) {
    successSubscription(planId).then((result) => {      
      if (result?.subscription) {
        // ✅ Update localStorage
        localStorage.setItem("paymentStatus", process.env.REACT_APP_PAID_SUBSCRIPTION_STATUS_ID);
        // localStorage.setItem("subscriptionId", result.subscription._id);
        // localStorage.setItem("orderId", result.subscription.orderId);

        // // If you’re storing user in localStorage:
        const storedUser = getFromLocalStorage();
        
        if (storedUser) {
          const updatedUser = {
            ...storedUser,
            paymentStatus: result.subscription.subscriptionStatus,
            subscriptionId: result.subscription._id,
          };
          saveToLocalStorage(updatedUser);
          dispatch(loginSuccess(updatedUser));
        }
      }
    }).catch((err) => {
      console.error("Subscription update failed", err);
    });
  }
}, [planId]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md text-center relative">
        <i className="fa-solid fa-circle-check text-green-500 text-6xl"></i>
        <h2 className="text-2xl font-bold text-gray-800 mt-4">
          Payment Successful!
        </h2>
        <p className="text-gray-600 mt-2">
          Thank you for your payment. Your transaction was completed successfully.
        </p>
        {/* {orderId && trackerId && (
          <div className="mt-4 text-gray-700">
            <p>
              <strong>Order ID:</strong> {orderId}
            </p>
            <p>
              <strong>Tracker ID:</strong> {trackerId}
            </p>
          </div>
        )} */}
        <p className="text-gray-500 mt-4 text-sm">
          Redirecting in <span className="font-bold">{countdown}</span> seconds...
        </p>
        <div className="absolute bottom-0 left-0 w-full h-2 bg-gray-300 rounded-b-lg">
          <div
            className="h-2 bg-themeColor transition-all duration-1000 ease-linear"
            style={{ width: `${(5 - countdown) * 20}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
